<!--
 * @Author: lee
 * @Date: 2020-12-04 10:46:29
 * @LastEditTime: 2020-12-09 17:12:08
 * @LastEditors: lee
 * @Description:
-->
<template>
    <div class="main">
        <topbar @change="query" />
        <div class="statistics-box">
            <div class="pay">
                <p class="label">支出</p>
                <p class="sum">¥{{ totalPayAmount }}</p>
            </div>
            <div class="refund">
                <p class="label">退款</p>
                <p class="sum">¥{{ totalRefundAmount }}</p>
            </div>
        </div>
        <div class="chart-box">
            <p class="title">收支统计</p>
            <div ref="chart" class="chart" :style="chartStyle"></div>
            <div class="empty-text" v-show="isEmpty">暂无数据</div>
        </div>
    </div>
</template>
<script type="text/javascript">
import Topbar from "./compoments/Topbar";
import { getStatisticsTransaction } from "@/api/account";
import Echarts from "@/libs/echarts.js";
import chartOption from "./compoments/chart";
let chart = null;
export default {
    components: {
        Topbar
    },
    data() {
        return {
            totalPayAmount: 0,
            totalRefundAmount: 0,
            mHeight: 0,
            isEmpty: false
        };
    },
    computed: {
        chartStyle() {
            return {
                height: `${this.mHeight + 15}px`
            }
        }
    },
    mounted() {
        this.$once("hook:beforeDestroy", () => {
            if (chart) {
                chart.dispose();
                chart = null;
            }
        });
    },
    methods: {
        query(params) {
            if (chart) {
                chart.showLoading();
            }
            getStatisticsTransaction(params)
                .then(res => {
                    if (res.succeed) {
                        const {
                            totalPayAmount,
                            totalRefundAmount,
                            items
                        } = res.body;
                        this.totalPayAmount = totalPayAmount;
                        this.totalRefundAmount = totalRefundAmount;
                        const option = this.initChartData(items);
                        if (!chart) {
                            this.initChart(option);
                        } else {
                            this.renderChart(option);
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        initChartData(data) {
            const dimensions = ['label', 'payAmount', 'refundAmount'];
            return {
                dataset: {
                    dimensions,
                    source: data
                }
            };
        },
        // 渲染chart数据
        renderChart(option) {
            this.setChartStyle(option);
            chart.setOption(option);
            chart.hideLoading();
        },
        // 重新设置chart样式
        setChartStyle(option) {
            const l = option.dataset.source.length;
            this.isEmpty = (l === 0);
            this.mHeight = l * 48 + 23;
            chart.resize({height: `${this.mHeight}px`});
        },
        // 初始化
        initChart(option) {
            this.$nextTick(() => {
                const copyOption = Object.assign(JSON.parse(JSON.stringify(chartOption)), option);
                chart = Echarts.init(this.$refs.chart);
                this.setChartStyle(copyOption);
                chart.setOption(copyOption);
                chart.hideLoading();
            });
        }
    }
};
</script>
<style lang="less" scoped>
.main {
    background: #f8f8f8;
    min-height: 100vh;
}

.main * {
    box-sizing: border-box;
}
.statistics-box {
    margin: 12px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
    .pay {
        color: #ff4646;
        &:before {
            background: #ff4646;
        }
    }
    .refund {
        color: #76b4ff;
        &:before {
            background: #76b4ff;
        }
    }
    .pay,
    .refund {
        flex: 1;
        padding-left: 38px;
        position: relative;
        &:before {
            content: "";
            position: absolute;
            top: 50%;
            left: 25px;
            transform: translateY(-50%);
            width: 5px;
            height: 5px;
            border-radius: 50%;
        }
    }
    .label {
        color: #666;
        font-size: 13px;
        line-height: 19px;
    }
    .sum {
        line-height: 23px;
        font-size: 16px;
        font-weight: 600;
    }
}
.chart-box {
    width: 100%;
    min-height: 140px;
    background: #fff;
    position: relative;
    .title {
        padding: 15px 0;
        font-size: 16px;
        color: #333;
        line-height: 23px;
        text-align: center;
        font-weight: 500;
    }
    .chart {
        box-sizing: border-box;
        // padding: 0 0 15px 20px;
        width: 100%;
        height: 600px;
    }
    .empty-text {
        position: absolute;
        top: 50%;
        width: 100%;
        transform: translateY(-50%);
        text-align: center;
        font-size: 18px;
        color: #999;
    }
}
</style>
